module.exports = __webpack_public_path__ + "img/0Q3A5801_L_Wood.2da6d149.jpg";